export const name = 'name';
export const weight = 'weight';
export const length = 'length';
export const width = 'width';
export const height = 'height';
export const serviceId = 'serviceId';
export const providerId = 'providerId';
export const confirmationId = 'confirmationId';
export const packageTypeId = 'packageTypeId';
export const domesticRateShopperGuid = 'domesticRateShopperGuid';
export const intlServiceId = 'intlServiceId';
export const intlProviderId = 'intlProviderId';
export const intlConfirmationId = 'intlConfirmationId';
export const intlPackageTypeId = 'intlPackageTypeId';
export const intlRateShopperGuid = 'intlRateShopperGuid';
export const noCustoms = 'noCustoms';
export const customsDescription = 'customsDescription';
export const customsValue = 'customsValue';
export const customsHarmonizationCode = 'customsHarmonizationCode';
export const customsCountry = 'customsCountry';
